import API from '../utils/api';
import LocalStorageService from './localStorage';
const localStorageService = LocalStorageService.getService();
// import { globalPageLimit } from '../constants/applicationConstants';

export const getDiagnosisCodesList = (payload = null) => {
  let queryString = '?limit=2000';
  if (payload && payload.next_page) {
    queryString += `&next_page=${encodeURIComponent(
      JSON.stringify(payload.next_page),
    )}`;
  }
  return API.get(`diagnostic-codes/diagnostic-codes${queryString}`, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
      'Cache-Control': `max-age=86400`,
      'Accept-Encoding': 'gzip, deflate',
    },
  });
};

export const getDiagnosisCodes = (id) => {
  return API.get(`diagnostic-codes/diagnostic-codes/${id}`, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const addDiagnosisCodes = (data) => {
  return API.post(`diagnostic-codes/diagnostic-codes`, data, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const updateDiagnosisCodes = (data) => {
  return API.put(`diagnostic-codes/diagnostic-codes/${encodeURIComponent(data.PK)}`, data, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const updateDiagnosisCodeStatus = (data) => {
  return API.post(`settings/patch/diagnostic_codes`, data, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};